// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"b03a20bb","269":"638fd731","355":"e640c2f1","422":"78ce91f1","455":"7761bc33"}[chunkId] + ".chunk.js";
};